<template>
    <div class="tag-selector">

        <div id="pin-tags">
            <a v-for="tag in selectedTags" :key="tag.id" @click.prevent="removeTag(tag)" href="#" title="Remove Tag" :data-tag="tag.id" class="remove-tag badge bg-secondary mx-1">{{ tag.name }} <strong class="ms-1">x</strong></a>
        </div>

        <div class="modal fade" id="add-tags" tabindex="-1" role="dialog" aria-labelledby="add-tags" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content text-start">
                    <div class="modal-header border-0">
                        <h5 class="modal-title">Select <span v-if="limit">Up To {{ limit }}</span> Tags:</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div id="selected-pin-tags" class="pb-3 px-3 float-none border-bottom">
                        <a v-for="tag in selectedTags" :key="tag.id" @click.prevent="tag.checked = false" href="#" title="Remove Tag" :data-tag="tag.id" class="remove-tag badge bg-secondary mx-1">{{ tag.name }} <strong class="ms-1">x</strong></a>
                        <span v-if="limit && selectedTags.length >= limit" class="badge bg-danger">Limit Reached</span>
                    </div>
                    <div v-if="suggestSuccess" class="modal-body">
                        <h2 class="display-5">Thank you for your suggestion</h2>
                        <p>Our mods regularly review tag suggestions with the goal of making Pin & Pop the most extensive pin trading resource available.</p>
                        <button @click="search = ''; suggestSuccess = false" class="btn btn-primary">Continue with tags</button>
                    </div>
                    <div v-else class="modal-body">

                        <ul class="nav nav-pills nav-fill tags-tabs mb-3">
                            <li class="nav-item">
                                <a class="nav-link active" id="characters-tab" data-bs-toggle="tab" href="#tag-characters" role="tab" aria-controls="characters" aria-selected="true">Characters</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="movies-tab" data-bs-toggle="tab" href="#tag-movies" role="tab" aria-controls="movies" aria-selected="false">Movies</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="series-tab" data-bs-toggle="tab" href="#tag-series" role="tab" aria-controls="series" aria-selected="false">Series / Shorts</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="rides-attractions-tab" data-bs-toggle="tab" href="#tag-rides-attractions" role="tab" aria-controls="rides-attractions" aria-selected="false">Rides / Parks</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="resorts-tab" data-bs-toggle="tab" href="#tag-resorts" role="tab" aria-controls="resorts" aria-selected="false">Resorts</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="events-tab" data-bs-toggle="tab" href="#tag-events" role="tab" aria-controls="events" aria-selected="false">Events</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="annuals-tab" data-bs-toggle="tab" href="#tag-annuals" role="tab" aria-controls="annuals" aria-selected="false">Annuals</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="holidays-tab" data-bs-toggle="tab" href="#tag-holidays" role="tab" aria-controls="holidays" aria-selected="false">Holidays</a>
                            </li>
                            <!-- <li v-if="!limit" class="nav-item">
                                <a class="nav-link" id="anniversaries-tab" data-bs-toggle="tab" href="#anniversaries" role="tab" aria-controls="anniversaries" aria-selected="false">Anniversaries</a>
                            </li> -->
                            <li class="nav-item">
                                <a class="nav-link" id="misc-tab" data-bs-toggle="tab" href="#tag-misc" role="tab" aria-controls="misc" aria-selected="false">More</a>
                            </li>
                        </ul>

                        <div class="tab-content">
                            <div class="tab-pane fade show active" id="tag-characters" role="tabpanel" aria-labelledby="characters-tab">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Characters</h2>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="w-100"><input v-model="search" @search="collapsed = true" type="search" class="form-control data-hj-allow" placeholder="filter"></label>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 mb-2">
                                        <div class="btn-group btn-group-sm" role="group">
                                            <button @click="tagFilter = null" type="button" class="btn" :class="[!tagFilter ? 'btn-dark' : 'btn-outline-secondary']">All</button>
                                            <button v-for="tag in franchises" :key="tag.id" @click="tagFilter = tag" type="button" class="btn" :class="[tagFilter && tagFilter.id === tag.id ? 'btn-dark' : 'btn-outline-secondary']">{{ tag.name }}</button>
                                        </div>
<!--                                        <a v-for="tag in franchises" :key="tag.id" @click.prevent="tagFilter = (!tagFilter || tagFilter.id !== tag.id ? tag : null)" href="#" class="me-2 btn btn-sm" :class="[tagFilter && tagFilter.id === tag.id ? 'btn-primary' : 'btn-outline-primary']">{{ tag.name }}</a>-->
                                        <a v-if="characters[0].length" @click.prevent="toggleAll" href="#" class="text-muted float-end">{{ collapsed ? 'expand' : 'collapse' }} all</a>
                                        <h4 v-else class="text-danger mt-4">No Characters found for <span v-if="tagFilter">{{ tagFilter.name }} </span>tag <span class="badge bg-danger">{{ search }}</span></h4>
                                    </div>
                                    <div v-for="(column, i) in characters" class="col-6 col-xl-3" :class="'order-'+(i === 1 ? 7 : (i+1)*2)+' order-xl-'+(i+1)">
                                        <div class="row">
                                            <div v-for="(parent, index) in column" :key="parent.id" class="character-container col-12 mb-2">
                                                <a class="text-dark" data-bs-toggle="collapse" :href="'#collapse-'+parent.id"><i class="fa-solid fa-caret-right me-1"></i> {{ parent.name }}</a>
                                                <div class="collapse" :class="{ show: !!search }" :id="'collapse-'+parent.id">
                                                    <div v-for="tag in tags.filter(t => (parent.id ? t.parent_id === parent.id : t.parent_id === null) && t.tagtype_id === 3).sort((a, b) => (a.name > b.name) ? 1 : -1)" :key="tag.id" class="col-12">
                                                        <div class="form-check">
                                                            <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" @change="toggleTag(tag.id)" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                                            <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="tag-movies" role="tabpanel" aria-labelledby="movies-tab">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Movies</h2>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="w-100"><input v-model="search" @search="collapsed = true" type="search" class="form-control" placeholder="filter"></label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 mb-2">
                                        <div class="btn-group btn-group-sm" role="group">
                                            <button @click="tagFilter = null" type="button" class="btn" :class="[!tagFilter ? 'btn-dark' : 'btn-outline-secondary']">All</button>
                                            <button v-for="tag in franchises" :key="tag.id" @click="tagFilter = tag" type="button" class="btn" :class="[tagFilter && tagFilter.id === tag.id ? 'btn-dark' : 'btn-outline-secondary']">{{ tag.name }}</button>
                                        </div>
<!--                                        <a v-for="tag in franchises" :key="tag.id" @click.prevent="tagFilter = (!tagFilter || tagFilter.id !== tag.id ? tag : null)" href="#" class="me-2 btn btn-sm" :class="[tagFilter && tagFilter.id === tag.id ? 'btn-primary' : 'btn-outline-primary']">{{ tag.name }}</a>-->
                                        <h4 v-if="!movies[0].length" class="text-danger mt-4">No Movies found for <span v-if="tagFilter">{{ tagFilter.name }} </span>tag <span class="badge bg-danger">{{ search }}</span></h4>
                                    </div>
                                    <div v-for="(column, i) in movies" class="col-6 col-xl-3" :class="'order-'+(i === 1 ? 7 : (i+1)*2)+' order-xl-'+(i+1)">
                                        <div class="row">
                                            <div v-for="tag in column" :key="tag.id" class="col-12 mb-2">
                                                <div class="form-check">
                                                    <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" @change="toggleTag(tag.id)" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                                    <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="tag-series" role="tabpanel" aria-labelledby="series-tab">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Series / Shorts</h2>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="w-100"><input v-model="search" @search="collapsed = true" type="search" class="form-control" placeholder="filter"></label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 mb-2">
                                        <div class="btn-group btn-group-sm" role="group">
                                            <button @click="tagFilter = null" type="button" class="btn" :class="[!tagFilter ? 'btn-dark' : 'btn-outline-secondary']">All</button>
                                            <button v-for="tag in franchises" :key="tag.id" @click="tagFilter = tag" type="button" class="btn" :class="[tagFilter && tagFilter.id === tag.id ? 'btn-dark' : 'btn-outline-secondary']">{{ tag.name }}</button>
                                        </div>
                                        <h4 v-if="!series[0].length" class="text-danger mt-4">No Series found for <span v-if="tagFilter">{{ tagFilter.name }} </span>tag <span class="badge bg-danger">{{ search }}</span></h4>
                                    </div>
                                    <div v-for="(column, i) in series" class="col-6 col-xl-3" :class="'order-'+(i === 1 ? 7 : (i+1)*2)+' order-xl-'+(i+1)">
                                        <div class="row">
                                            <div v-for="tag in column" :key="tag.id" class="col-12 mb-2">
                                                <div class="form-check">
                                                    <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" @change="toggleTag(tag.id)" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                                    <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="tag-rides-attractions" role="tabpanel" aria-labelledby="rides-attractions-tab">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Rides / Attractions</h2>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="w-100"><input v-model="search" @search="collapsed = true" type="search" class="form-control" placeholder="filter"></label>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 mb-2">
                                        <h4 v-if="!rides[0].length" class="text-danger mt-4">No Rides / Attractions found for tag <span class="badge bg-danger">{{ search }}</span></h4>
                                    </div>
                                    <div v-for="(column, i) in rides" class="col-6 col-xl-3" :class="'order-'+(i === 1 ? 7 : (i+1)*2)+' order-xl-'+(i+1)">
                                        <div class="row">
                                            <div v-for="tag in column" :key="tag.id" class="col-12 mb-2">
                                                <div class="form-check">
                                                    <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" @change="toggleTag(tag.id)" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                                    <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Parks / Lands</h2>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 mb-2">
                                        <h4 v-if="!parks[0].length" class="text-danger mt-4">No Parks / Lands found for tag <span class="badge bg-danger">{{ search }}</span></h4>
                                    </div>
                                    <div v-for="(column, i) in parks" class="col-6 col-xl-3" :class="'order-'+(i === 1 ? 7 : (i+1)*2)+' order-xl-'+(i+1)">
                                        <div class="row">
                                            <div v-for="tag in column" :key="tag.id" class="col-12 mb-2">
                                                <div class="form-check">
                                                    <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" @change="toggleTag(tag.id)" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                                    <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="tab-pane fade" id="tag-resorts" role="tabpanel" aria-labelledby="resorts-tab">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Resorts / Hotels</h2>
                                    </div>
                                </div>
                                <div class="row">
                                    <div v-for="(column, i) in resorts" class="col-6 col-xl-3" :class="'order-'+(i === 1 ? 7 : (i+1)*2)+' order-xl-'+(i+1)">
                                        <div class="row">
                                            <div v-for="tag in column" :key="tag.id" class="col-12 mb-2">
                                                <div class="form-check">
                                                    <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" @change="toggleTag(tag.id)" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                                    <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="tag-events" role="tabpanel" aria-labelledby="events-tab">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Events</h2>
                                    </div>
                                </div>
                                <div class="row">
                                    <div v-for="(column, i) in events" class="col-6 col-xl-3" :class="'order-'+(i === 1 ? 7 : (i+1)*2)+' order-xl-'+(i+1)">
                                        <div class="row">
                                            <div v-for="tag in column" :key="tag.id" class="col-12 mb-2">
                                                <div class="form-check">
                                                    <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" @change="toggleTag(tag.id)" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                                    <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="tag-annuals" role="tabpanel" aria-labelledby="annuals-tab">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Annuals</h2>
                                    </div>
                                </div>
                                <div class="row">
                                    <div v-for="(column, i) in annuals" class="col-6 col-xl-3" :class="'order-'+(i === 1 ? 7 : (i+1)*2)+' order-xl-'+(i+1)">
                                        <div class="row">
                                            <div v-for="tag in column" :key="tag.id" class="col-12 mb-2">
                                                <div class="form-check">
                                                    <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" @change="toggleTag(tag.id)" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                                    <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="tag-holidays" role="tabpanel" aria-labelledby="holidays-tab">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Holidays</h2>
                                    </div>
                                </div>
                                <div class="row">
                                    <div v-for="(column, i) in holidays" class="col-6 col-xl-3" :class="'order-'+(i === 1 ? 7 : (i+1)*2)+' order-xl-'+(i+1)">
                                        <div class="row">
                                            <div v-for="tag in column" :key="tag.id" class="col-12 mb-2">
                                                <div class="form-check">
                                                    <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" @change="toggleTag(tag.id)" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                                    <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div v-if="!limit" class="tab-pane fade" id="anniversaries" role="tabpanel" aria-labelledby="anniversaries-tab">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Anniversaries</h2>
                                    </div>
                                </div>
                                <div class="row">
                                    <div v-for="(tag, i) in tags.filter(tag => tag.tagtype_id === 12).sort((a, b) => parseInt(a.name) - parseInt(b.name))" class="col-6 col-xl-3 mb-2">
                                        <div class="form-check">
                                            <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                            <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="tab-pane fade" id="tag-misc" role="tabpanel" aria-labelledby="misc-tab">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Franchises</h2>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div v-for="tag in franchises" :key="tag.id" class="col-6 col-xl-3 mb-2">
                                        <div class="form-check">
                                            <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                            <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Miscellaneous Tags</h2>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div v-for="(column, i) in misc" class="col-6 col-xl-3" :class="'order-'+(i === 1 ? 7 : (i+1)*2)+' order-xl-'+(i+1)">
                                        <div class="row">
                                            <div v-for="tag in column" :key="tag.id" class="col-12 mb-2">
                                                <div class="form-check">
                                                    <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                                    <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <template v-if="!limit">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h2>Anniversaries</h2>
                                    </div>
                                </div>
                                <div class="row">
                                    <div v-for="(tag, i) in tags.filter(tag => tag.tagtype_id === 12).sort((a, b) => parseInt(a.name) - parseInt(b.name))" class="col-6 col-xl-3 mb-2">
                                        <div class="form-check">
                                            <input :disabled="limit > 0 && selectedTags.length >= limit && !tag.checked" :data-tag="tag.id" class="form-check-input" type="checkbox" name="tags[]" :value="tag.id" :id="'tag-' + tag.id" v-model="tag.checked">
                                            <label class="form-check-label" :for="'tag-' + tag.id">{{ tag.name }}</label>
                                        </div>
                                    </div>
                                </div>
                                </template>
                            </div>

                            <div v-if="!tagFound" class="row">
                                <div class="col text-center mt-5">
                                    Should the P&P Mods include <span class="badge bg-dark">{{ search }}</span> as a tag?
                                    <div class="mt-2">
                                        <a @click.prevent="suggestTag" href="#" class="btn btn-outline-success">Suggest <strong>{{ search }}</strong></a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Done</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TagSelector',
        props: ['allTags', 'old', 'initial', 'limit'],
        data () {
            return {
                cols: 4,
                tags: [],
                siblings: [],
                collapsed: true,
                search: '',
                suggestSuccess: false,
                tagFilter: null,
                allCharacters: [],
                allParents: [],
                franchises: []
            }
        },
        computed: {
            selectedTags () {
                return this.tags.filter(tag => tag.checked);
            },
            tagFound () {
                return !this.search || this.tags.filter(tag => {
                    return tag.name.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().includes(this.search.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().trim())
                }).length;
            },
            characters () {
                let characters = this.allCharacters.filter(tag => {
                    return tag.name.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().includes(this.search.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().trim())
                });
                // characters.sort((a, b) => (a.name > b.name) ? 1 : -1);

                let searchParents = this.allParents.filter(tag => {
                    return tag.name.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().includes(this.search.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().trim())
                });

                let matchParents = [...new Set(characters.map(tag => {
                    return this.allParents.find(t => t.id === tag.parent_id);
                }).filter(tag => tag !== undefined))];

                let parents = [...new Set([...matchParents, ...searchParents])];
                // parents.sort((a, b) => (a.name > b.name) ? 1 : -1);
                parents.sort(this.compare);

                if (this.tagFilter) {
                    parents = parents.filter(tag => tag.id === this.tagFilter.id || tag.parent_id === this.tagFilter.id);
                }

                let columns = []
                let mid = Math.ceil(parents.length / this.cols)
                for (let col = 0; col < this.cols; col++) {
                    columns.push(parents.slice(col * mid, col * mid + mid))
                }
                return columns
            },
            movies () {
                let movies = this.tags.filter(tag => tag.tagtype_id === 5).filter(tag => {
                    return tag.name.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().includes(this.search.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase())
                }).sort(this.compare);
                // .sort((a, b) => (a.name > b.name) ? 1 : -1);

                if (this.tagFilter) {
                    movies = movies.filter(tag => tag.parent_id === this.tagFilter.id);
                }

                let columns = []
                let mid = Math.ceil(movies.length / this.cols)
                for (let col = 0; col < this.cols; col++) {
                    columns.push(movies.slice(col * mid, col * mid + mid))
                }
                return columns
            },
            series () {
                let series = this.tags.filter(tag => tag.tagtype_id === 6 || tag.tagtype_id === 15).filter(tag => {
                    return tag.name.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().includes(this.search.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase())
                }).sort(this.compare);

                if (this.tagFilter) {
                    series = series.filter(tag => tag.parent_id === this.tagFilter.id);
                }

                let columns = []
                let mid = Math.ceil(series.length / this.cols)
                for (let col = 0; col < this.cols; col++) {
                    columns.push(series.slice(col * mid, col * mid + mid))
                }
                return columns
            },
            rides () {
                let rides = this.tags.filter(tag => tag.tagtype_id === 4).filter(tag => {
                    return tag.name.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().includes(this.search.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase())
                }).sort(this.compare);
                let columns = []
                let mid = Math.ceil(rides.length / this.cols)
                for (let col = 0; col < this.cols; col++) {
                    columns.push(rides.slice(col * mid, col * mid + mid))
                }
                return columns
            },
            parks () {
                let parks = this.tags.filter(tag => tag.tagtype_id === 7).filter(tag => {
                    return tag.name.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().includes(this.search.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase())
                }).sort(this.compare);
                let columns = []
                let mid = Math.ceil(parks.length / this.cols)
                for (let col = 0; col < this.cols; col++) {
                    columns.push(parks.slice(col * mid, col * mid + mid))
                }
                return columns
            },
            resorts () {
                let resorts = this.tags.filter(tag => tag.tagtype_id === 11).sort(this.compare);
                // .filter(tag => {
                //     return tag.name.toLowerCase().includes(this.search.toLowerCase())
                // });
                let columns = []
                let mid = Math.ceil(resorts.length / this.cols)
                for (let col = 0; col < this.cols; col++) {
                    columns.push(resorts.slice(col * mid, col * mid + mid))
                }
                return columns
            },
            events () {
                let events = this.tags.filter(tag => tag.tagtype_id === 10).sort(this.compare);
                // .filter(tag => {
                //     return tag.name.toLowerCase().includes(this.search.toLowerCase())
                // });
                let columns = []
                let mid = Math.ceil(events.length / this.cols)
                for (let col = 0; col < this.cols; col++) {
                    columns.push(events.slice(col * mid, col * mid + mid))
                }
                return columns
            },
            annuals () {
                let annuals = this.tags.filter(tag => tag.tagtype_id === 8).sort(this.compare);
                // .filter(tag => {
                //     return tag.name.toLowerCase().includes(this.search.toLowerCase())
                // });
                let columns = []
                let mid = Math.ceil(annuals.length / this.cols)
                for (let col = 0; col < this.cols; col++) {
                    columns.push(annuals.slice(col * mid, col * mid + mid))
                }
                return columns
            },
            holidays () {
                let holidays = this.tags.filter(tag => tag.tagtype_id === 9).sort(this.compare);
                // .filter(tag => {
                //     return tag.name.toLowerCase().includes(this.search.toLowerCase())
                // });
                let columns = []
                let mid = Math.ceil(holidays.length / this.cols)
                for (let col = 0; col < this.cols; col++) {
                    columns.push(holidays.slice(col * mid, col * mid + mid))
                }
                return columns
            },
            misc () {
                let misc = this.tags.filter(tag => tag.tagtype_id === 14).sort(this.compare);
                // .filter(tag => {
                //     return tag.name.toLowerCase().includes(this.search.toLowerCase())
                // });
                let columns = []
                let mid = Math.ceil(misc.length / this.cols)
                for (let col = 0; col < this.cols; col++) {
                    columns.push(misc.slice(col * mid, col * mid + mid))
                }
                return columns
            },
        },
        mounted() {
            document.getElementById('add-tags').addEventListener('hidden.bs.modal', () => {
                this.search = '';
                VueEvent.$emit('modifiedTags', this.selectedTags);
            });
        },
        created() {
            this.tags = this.allTags.filter(tag => {
                tag.checked = this.initial.find(t => t.id === tag.id) || (this.old && this.old.find(t => Number(t) === tag.id));
                return tag.tagtype_id !== 1;
            });

            this.allCharacters = this.tags.filter(tag => tag.tagtype_id === 3).sort((a, b) => (a.name > b.name) ? 1 : -1);

            let parents = this.allCharacters.filter(tag => tag.parent_id).map(tag => {
                return this.tags.find(t => t.id === tag.parent_id && t.tagtype_id !== 3);
            }).filter(tag => tag !== undefined);

            this.allParents = [...new Set(parents)];
            this.allParents.sort((a, b) => (a.name > b.name) ? 1 : -1)
            this.allParents.push({id: 10000, name: ' Various Characters', tagtype_id: 2 });

            this.allCharacters.filter(tag => !tag.parent_id).forEach((tag, i) => {
                tag.parent_id = 10000;
            });

            this.franchises = this.tags.filter(tag => tag.tagtype_id === 13);

            // this.parks = this.tags.filter(tag => tag.tagtype_id === 7);

            axios.get('/api/tags/siblings')
                .then(response => {
                    this.siblings = response.data;
                })
                .catch(function (error) {
                    // handle error
                    // console.log(error.toJSON());
                });
        },
        methods: {
            toggleAll () {
                document.querySelectorAll('#characters .collapse').forEach(el => {
                    if (this.collapsed) {
                        el.classList.add('show');
                    } else {
                        el.classList.remove('show');
                    }
                });
                this.collapsed = !this.collapsed;
            },

            toggleTag (id) {
                if (!this.limit) {
                    if (this.tags.find(t => t.id === id && t.checked)) {
                        let siblings = this.siblings.filter(t => t.tag_id === id);
                        siblings.forEach(s => {
                            this.tags.find(t => t.id === s.add_tag_id).checked = true;
                        });
                    }
                }
            },

            removeTag (tag) {
                tag.checked = false;
                VueEvent.$emit('modifiedTags', this.selectedTags);
            },

            suggestTag () {
                axios.post('/tags/suggest', { tag: this.search })
                    .then(response => {
                        this.suggestSuccess = true;
                    })
                    .catch(function (error) {
                        // handle error
                        // console.log(error.toJSON());
                    });
            },

            compare (a, b) {
                let aName = this.removeArticles(a.name);
                let bName = this.removeArticles(b.name);

                return aName.localeCompare(bName);
            },

            removeArticles (name) {
                return name.replace(/^(a |an |the )/i, '')
            },
        }
    }
</script>
